import React from 'react';

function Footer() {
  return (
    <footer className="main-footer text-sm text-center text-md-start px-3 py-2 bg-light text-white">
      <div className="row align-items-center">
        {/* Left Side */}
        <div className="col-12 col-md-6 mb-2 mb-md-0">
          <strong>
            &copy; 2025–2026{" "}
            <a
              href="https://www.socialpartners.in/"
              className="text-dark text-decoration-underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Social Partners Technologies
            </a>.
          </strong>{" "}
          All rights reserved.
        </div>

        {/* Right Side */}
        <div className="col-12 col-md-6 text-md-end">
          <span>
            <b>Version:</b> 3.0.1
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
